// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n.loader-wrapper{\r\n    position: relative;\r\n    height: 50%;\r\n    margin: 50px 0;\r\n}\r\n\r\n.loader_svg{\r\n    fill: yellow;\r\n    enable-background:new 0 0 50 50;\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 15%;\r\n    transform: translate(-50%,50%);\r\n}\r\n", ""]);
// Exports
module.exports = exports;
